export const ThemeNames = {
  mk: 'mk',
  clario: 'clario',
  web2app: 'web2app',
  wta: 'wta',
  goi: 'goi'
}

